import React, { useState } from "react";
import DTOLeaveARModal from "./DTOLeaveARModal";
import LeaveARModalPresenter from "./LeaveARModalPresenter";
import { useAppSelector } from "../../../../infra/hooks";

import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  leave_data?: any;
  leaveHistory: any;
  leaveInsight: any;
  canAct: any;
}

const LeaveARModalController = ({
  isModalOpen,
  closeModal,
  leave_data,
  leaveHistory,
  leaveInsight,
  canAct,
}: ModalInterface) => {
  const userId = useAppSelector((state) => state.authSlice.user_id);
  const { t } = useTranslation();
  const [leaveActions, setLeaveActions] = useState([]);

  const saveLeaveActions = (data: any) => {
    setLeaveActions(data);
  };

  const request_actionRequired = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOLeaveARModal setAllActionsOfLeave={saveLeaveActions} />

      <LeaveARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        leave_data={leave_data}
        leaveActions={leaveActions}
        leaveHistory={leaveHistory}
        leaveInsight={leaveInsight}
        userId={userId}
        handleSubmitAR_Request={request_actionRequired}
        canAct={canAct}
      />
    </div>
  );
};

export default LeaveARModalController;
